function PSAController(
  userViewService,
  psaService,
  fleetService,
  analysisService
) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.psaService = psaService;
    ctrl.fleetService = fleetService;
    ctrl.analysisService = analysisService;
    userViewService.setView('psa');
    ctrl.emuList = null;
    ctrl.fleetList = null;
    ctrl.trainList = null;
    ctrl.eventList = null;
    ctrl.carList = null;
    ctrl.loadEMUs();
    ctrl.loadTrains();
    ctrl.loadEvents();
    ctrl.loadCars();
    // ctrl.loadFleet();
  };

  ctrl.script = {};

  ctrl.loadEMUs = () => {
    ctrl.psaService.getEmus().then(function(data) {
      ctrl.emuList = data;
    });
  };

  ctrl.loadFleet = () => {
    ctrl.fleetService.getAll().then(function(data) {
      ctrl.fleetList = data;
    });
  };

  ctrl.loadTrains = () => {
    ctrl.psaService.getTrains().then(function(data) {
      ctrl.trainList = data;
    });
  };

  ctrl.loadEvents = () => {
    ctrl.analysisService.eventsByGroup().then(function(data) {
      ctrl.eventList = data;
    });
  };

  ctrl.loadCars = () => {
    ctrl.psaService.getCars().then(function(data) {
      ctrl.carList = data;
    });
  };
}

angular.module('psa.module').controller('PSAController', PSAController);
